class GeneralHelper {
	constructor() {
		this._initEvents()
	}

	_initEvents = () => {
		document.querySelector(".bb-print-page")?.addEventListener("click", (event) => {
			event.preventDefault()
			window.print()
		})

		document.querySelector(".bb-history-back")?.addEventListener("click", (event) => {
			event.preventDefault()
			history.back()
		})

		document.querySelector(".bb-scroll-top-with-focus")?.addEventListener("click", (event) => {
			event.preventDefault()
			this._scrollTop(true)
		})

		document.querySelector(".bb-scroll-top")?.addEventListener("click", (event) => {
			event.preventDefault()
			this._scrollTop()
		})
	}

	/**
	 * scrollTop with focus
	 * @param withFocus to focus first element
	 */
	_scrollTop(withFocus) {
		if (withFocus) {
			this._scrollTo(0, () => {
				let focusable = document.querySelectorAll(
					'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
				)
				focusable[0].focus()
			})
		} else {
			this._scrollTo()
		}
	}

	/**
	 * scrollTo with callback
	 * @param offset to scroll to
	 * @param callback function
	 */
	_scrollTo(offset = 0, callback = () => {}) {
		const fixedOffset = offset.toFixed()
		const onScroll = () => {
			if (window.pageYOffset.toFixed() === fixedOffset) {
				window.removeEventListener("scroll", onScroll)
				callback()
			}
		}

		window.addEventListener("scroll", onScroll)
		onScroll()
		window.scrollTo({
			top: offset,
			behavior: "smooth",
		})
	}
}

export default GeneralHelper
